import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import StatusBadge from "../subcomponents/StatusBadge";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

const trimDesc = (desc) => {
  if (!desc || !desc.trim()) return "";
  return desc.length > 256 ? `${desc.substring(0, 256)}...` : desc;
};

const CustomStatusRow = ({
  field,
  index,
  baseVisibleCount,
  isFirst,
  isLast,
  onNameChange,
  onOpen,
  onMoveUp,
  onMoveDown,
  onDelete,
}) => {
  const positionNumber = index + baseVisibleCount + 1;

  return (
    <div className="individual-workflow" id={`workflowstatus_${index}`}>
      <div className="individual-workflow-status">
        <span className="status-index">{positionNumber}</span>
        <div className="field-container">
          <div className="row">
            <div className="col-md-12">
              <FluentProvider theme={webLightTheme}>
                <StatusBadge status={field} />
              </FluentProvider>
              {/* <Form.Control
                id="userNameFull"
                name="userNameFull"
                placeholder="Enter Workflow Name"
                value={field?.Name || ""}
                onChange={(e) => onNameChange(field.Id, e.target.value)}
              /> */}
            </div>
            <div className="col-md-12 field-description">{trimDesc(field?.Description)}</div>
          </div>
        </div>
        <Button className="btn-icon1 open-modal" onClick={() => onOpen(field)} type="button" />
      </div>

      <div className="field-controls">
        <Button className={`btn-icon1 rotate-180 arrow${isFirst ? "-disabled" : ""}`} disabled={isFirst} onClick={onMoveUp} type="button" />
        <Button className={`btn-icon1 arrow${isLast ? "-disabled" : ""}`} disabled={isLast} onClick={onMoveDown} type="button" />
        <Button className="btn-icon1 delete" onClick={onDelete} type="button" />
      </div>
    </div>
  );
};

CustomStatusRow.propTypes = {
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  baseVisibleCount: PropTypes.number.isRequired,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  onNameChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CustomStatusRow;
